var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ResultTable',{staticClass:"mt-4",attrs:{"columns":_vm.columns,"data":_vm.zoneDosageTableData,"footer":_vm.footer,"loading":_vm.loading,"variant":"centered"},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }